export enum CisgenicTaskStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
  Cancelled = 4,
}

export interface CisgenicTaskStep {
  stepName: string
  stepOrder?: number
  status: CisgenicTaskStatus
  progress: number
  processedItems: number
  totalItems: number
  startedAt: string | null
  completedAt: string | null
}

export interface UploadCommonDataResponse {
  success: boolean
  taskId: string
  message: string
  trackingUrl: string
  progressUrl: string
  cancelUrl: string
  info: string
}

export interface CisgenicTaskProgress {
  taskId: string
  status: CisgenicTaskStatus
  progress: number
  currentStep: string | null
  steps: CisgenicTaskStep[]
  estimatedTimeRemaining: number | null
  createdAt: string
  startedAt: string | null
  completedAt: string | null
  errorMessage: string | null
}

export interface ActiveTaskResponse {
  hasActiveTask: boolean
  message: string
  taskId?: string
  status?: string
  progress?: number
  currentStep?: string | null
  completedSteps?: number
  totalSteps?: number
  trackingUrl?: string
  progressUrl?: string
  cancelUrl?: string
  createdAt?: string
  startedAt?: string | null
}

export interface CisgenicTaskUpdateEvent {
  taskId: string
  taskType: string
  objectId: number
  status: CisgenicTaskStatus
  progress: number
  currentStep: string | null
  stepProgress: number | null
  processedItems: number | null
  totalItems: number | null
  message: string | null
  errorMessage: string | null
  estimatedTimeRemaining: number | null
  updatedAt: string
  steps: CisgenicTaskStep[]
}
